import { render } from "./Confetti.vue?vue&type=template&id=160e4a0d&scoped=true"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"

import "./Confetti.vue?vue&type=style&index=0&id=160e4a0d&scoped=true&lang=css"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160e4a0d"]])

export default __exports__